var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner text-primary",class:[_vm.fixed ? 'spinner__fixed' : 'spinner__default']},[_c('b-spinner',{staticClass:"align-middle"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }